///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export const USER_ACTIVITY_OVERVIEW_BASE_URL = 'user-activity-overview';
